module.exports = __webpack_public_path__ + "static/img/主图.ccc440c.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/match_result/figure/1/主图.png
// module id = Vglf
// module chunks = 1